import React from 'react'
import { FaChartBar } from 'react-icons/fa'
import { BaseStepCard, StepHeader, StepContent } from './StepCard'
import { StatCard, gradients } from '../styles'

interface DatasetStatsCardProps {
  selectedTrainingSources: string[]
  classDistribution: Array<{ name: string }>
  annoStats:
    | {
        statistics: {
          total_unannotated_images: number
          total_annotated_images: number
          total_annotations: number
        }
      }
    | undefined
}

export const DatasetStatsCard: React.FC<DatasetStatsCardProps> = ({
  selectedTrainingSources,
  classDistribution,
  annoStats,
}) => {
  return (
    <BaseStepCard>
      <StepHeader $gradient={gradients.stats}>
        Dataset Statistics
        <FaChartBar />
      </StepHeader>
      <StepContent>
        <div className="d-flex flex-column gap-3">
          <StatCard>
            <div className="stat-number">
              {selectedTrainingSources?.length > 0
                ? classDistribution.filter((item) => item.name !== 'Unknown').length || 0
                : 0}
            </div>
            <div className="text-muted">Classes</div>
          </StatCard>

          <StatCard>
            <div className="stat-number">
              {selectedTrainingSources?.length > 0
                ? (annoStats?.statistics.total_unannotated_images || 0) +
                    (annoStats?.statistics.total_annotated_images || 0) || 0
                : 0}
            </div>
            <div className="text-muted">Total Images</div>
          </StatCard>

          <StatCard>
            <div className="stat-number">
              {selectedTrainingSources?.length > 0
                ? annoStats?.statistics.total_annotations || 0
                : 0}
            </div>
            <div className="text-muted">Annotations</div>
          </StatCard>
        </div>
      </StepContent>
    </BaseStepCard>
  )
}
